import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FAIcon from './FAIcon.jsx';
import NotificationComponent from './NotificationComponent.jsx';
import Login from '../components/Login.jsx';

import { setNotification } from '../reducers/notification';
import { selectEvent } from '../reducers/events';
import { switchView } from '../reducers/view';
import { logOut, setAdmin } from '../reducers/login';

import { logout } from '../services/loginService';

const mapStateToProps = state => ({
  loggedIn: state.login.loggedIn,
  view: state.view.view
});

const mapDispatchToProps = dispatch => ({
  logOut: () => doLogout(dispatch),
  setAdminStatus: isAdmin => dispatch(setAdmin(isAdmin)),
  changeView: viewName => dispatch(switchView(viewName)),
  selectEvent: eventId => dispatch(selectEvent(eventId))
});

function doLogout(dispatch) {
  dispatch(logOut());
  dispatch(setNotification('Uloskirjautuminen onnistui'));
  dispatch(setAdmin(false));
}

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = { showLoginForm: false };

    this.openLoginForm = this.openLoginForm.bind(this);
    this.closeLoginForm = this.closeLoginForm.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  getEditorButton(loggedIn) {
    if (loggedIn && this.props.view !== 'EDITOR') {
      return (
        <a role="button" tabIndex="0" className="login" onClick={this.handleSwitchToEditor}>
          Lisää uusi harjoitus
        </a>
      );
    }

    return <div />;
  }

  handleSwitchToEditor = () => {
    this.props.selectEvent('');
    this.props.changeView('EDITOR');
  }

  loginButton(loggedIn) {
    if (!loggedIn) {
      return (
        <a href="/login" className="login" onClick={this.openLoginForm}>
          <FAIcon icon="sign-in" />
          Kirjaudu sisään
        </a>
      );
    }

    return (
      <a href="/logout" className="login" onClick={this.logOut}>
        <FAIcon icon="sign-out" />
        Kirjaudu ulos
      </a>
    );
  }

  openLoginForm(e) {
    e.preventDefault();
    this.setState({ showLoginForm: true });
  }

  closeLoginForm() {
    this.setState({ showLoginForm: false });
  }

  logOut(e) {
    e.preventDefault();
    logout().then(this.props.logOut);
    this.props.changeView('CALENDAR');
  }

  render() {
    return (
      <nav className="navbar navbar-static-top">
        <div className="navbar-header">
          <div>
            <a href="http://www.turvallisuuskomitea.fi/">
              <img src="https://turvallisuuskomitea.fi/images/yootheme/TK_logo.png" alt="logo" height={60} />
            </a>
          </div>
        </div>

        <ul className="nav navbar-top-links navbar-right">
          <li>{this.getEditorButton(this.props.loggedIn)}</li>
          <li>{this.loginButton(this.props.loggedIn)}</li>
        </ul>

        <Login close={this.closeLoginForm} show={this.state.showLoginForm} />
        <NotificationComponent />
      </nav>
    );
  }
}

Header.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  logOut: PropTypes.func.isRequired,
  changeView: PropTypes.func.isRequired,
  selectEvent: PropTypes.func.isRequired,
  view: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx